import { z } from 'zod';

export interface PaymentProviderDto {
  id: string;
  type: 'PAYPAL' | 'LAVATOP';
  name: string;
  mode: 'sandbox' | 'live';
  isActive: boolean;
  /** true → расшифровка кредов провалилась (несовпадение PAYMENTS_ENC_KEY). */
  credentialsError: boolean;
  clientIdMasked: string | null;
  clientSecretMasked: string | null;
  webhookIdMasked: string | null;
  apiKeyMasked: string | null;
  webhookSecretMasked: string | null;
  offers: Record<string, string> | null;
}

export interface CityProviderLinkDto {
  cityId: string;
  providerId: string;
  priority: number;
  isActive: boolean;
  provider: { id: string; name: string; type: 'PAYPAL' | 'LAVATOP'; isActive: boolean };
}

/** Форма провайдера в админке (секреты опциональны при апдейте). */
export const ProviderFormSchema = z.object({
  type: z.enum(['PAYPAL', 'LAVATOP']),
  name: z.string().min(1, 'Укажите название'),
  mode: z.enum(['sandbox', 'live']),
  isActive: z.boolean(),
  clientId: z.string().optional(),
  clientSecret: z.string().optional(),
  webhookId: z.string().optional(),
  apiKey: z.string().optional(),
  webhookSecret: z.string().optional(),
  offerEnergy10: z.string().optional(),
  offerEnergy20: z.string().optional(),
  offerEnergy50: z.string().optional(),
  offerProPromo: z.string().optional(),
});
export type ProviderFormValues = z.infer<typeof ProviderFormSchema>;
